<template>
  <div id="contenedor-editar-ente-fiscalizador">
    <v-form
      v-model="esFormularioValido"
      ref="editarEnteFiscalizador">
      <v-card>
        <v-card-title class="secondary--text">
          Editar ente fiscalizador
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Descripción del Ente Fiscalizador"
            v-model="enteFiscalizador.descripcion"
            :rules="[mixReglas.requerido]"
            v-on:keypress.enter="mixActualizarEnteFiscalizador"
            required
          ></custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarEnteFiscalizador"
            :disabled="!esFormularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoEntesFiscalizadores from './mixCatalogoEntesFiscalizadores';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogoEntesFiscalizadoresEditar',
  mixins: [mixCatalogoEntesFiscalizadores],
  props: {
    enteFiscalizadorEditar: Object,
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      enteFiscalizador: {
        descripcion: this.enteFiscalizadorEditar.descripcion,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.editarEnteFiscalizador.reset();
    },
  },
};
</script>

<style lang="scss">
</style>
